import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { AdminServiceAccountsRoutingModule } from './admin-service-accounts-routing.module';
import { AdminServiceAccountsComponent } from './admin-service-accounts.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AdminServiceAccountsRoutingModule,
    NgxDatatableModule,
    SharedPipesModule,
    NgxTippyModule,
  ],
  declarations: [AdminServiceAccountsComponent],
})
export class AdminServiceAccountsModule {}
